@if (!showViewMode) {
  <div [formGroup]="form" [ngClass]="{'inverted': invertedColor}"
    class="component-wrapper">
    <div class="label-wrapper">
      @if (label) {
        <label
          [for]="HTML_ID"
          [ngClass]="{'small': isSmallLabel}">
          <span [attr.data-cy]="labelCypressTag">{{label}}</span>
        </label>
      }
      @if (hasWarningStar) {
        <app-warning-star
          [attr.data-cy]="warningStarCypressTag"
        [type]="warningLevel"></app-warning-star>
      }
      <div class="label-information">
        <ng-container *ngTemplateOutlet="labelInformation"></ng-container>
      </div>
    </div>
    <div [attr.data-cy]="inputWrapperCypressTag" [ngClass]="{
        'invalid': !isValid,
        'focus': isFocused,
        'disabled': isDisabled,
        'alternate-background': alternateBackground,
        'expiring-date': expiringDate}"
      class="input-wrapper">
      <app-tooltip [disable]="inputHasEllipsis"
        [dynamic]="false" [message]="datepickerHelper.dateFormatting(form.get(FORM_CONTROL_NAME).value)">
        <input #datepicker="ngbDatepicker"
          (blur)="inputBlur.emit($event)"
          (click)="clickInput($event)"
          (keydown)="inputKeyDown.emit($event)"
          (mouseenter)="toggleTooltip($event)"
          (closed)="closedDatepickerHandler()"
          (dateSelect)="selectDataHandler($event)"
          [attr.data-cy]="textInputCypressTag"
          [maxDate]="maxDate"
          [minDate]="minDate"
          [dayTemplateData]="retrieveTemplateData"
          [dayTemplate]="todayTemplate"
          [displayMonths]="displayMonths"
          [footerTemplate]="footerTemplate"
          [formControlName]="FORM_CONTROL_NAME"
          [id]="HTML_ID"
          [ngStyle]="inputDateStyle"
          [placeholder]="placeholder"
          [disabled]="isDisabled"
          [value]="datepickerHelper.dateFormatting(form.get(FORM_CONTROL_NAME).value)"
          class="text-ellipsis input"
          restoreFocus="body"
          ngbDatepicker>
      </app-tooltip>
      <div class="icon-wrapper">
        <button (click)="clickInput($event)"
          [attr.data-cy]="datepickerCypressTag"
          [disabled]="isInputDisabled"
          class="input-button">
          <span class="iwp-icon-gen_calendar"></span>
        </button>
      </div>
    </div>
    @if (showMessages) {
      @for (message of messages | anyKeyValue; track message) {
        @if (message.value.length > 0) {
          <app-warning-inline
            [warningInlineLabelsArray]="message.value"
          [warningType]="message.key"></app-warning-inline>
        }
      }
    }
  </div>
} @else {
  <div [ngClass]="{'inverted': invertedColor}" class="component-view-wrapper">
    @if (label) {
      <label class="label-wrapper" [ngClass]="{'small': isSmallLabel}">
        <span class="input-date-view-mode-label" [attr.data-cy]="labelCypressTag">{{label}}</span>
      </label>
    }
    <div [attr.data-cy]="inputWrapperCypressTag">
      <span [ngStyle]="animationStyle"
        [attr.data-cy]="textInputCypressTag"
        class="input-date-view-mode-text">{{datepickerHelper.dateFormatting(
      form.get(FORM_CONTROL_NAME).value) | undefinedValue}}</span>
    </div>
  </div>
}

<ng-template #todayTemplate let-date let-data="data" let-disabled="disabled">
  <span [class.disabled]="disabled"
          [ngClass]="{'today-template': datepickerHelper.isToday(date, timezone),
          'custom-day-template': datepickerHelper.isSelected(data, date),
          'selected-day': datepickerHelper.isSelected(date, form.get(FORM_CONTROL_NAME).value)}"
  class="custom-day">{{date.day}}</span>
</ng-template>

<ng-template #footerTemplate>
  <button (click)="datepicker.navigateTo(todayDate)"
    [disabled]="isDisabledCalendarButton"
    [ngClass]="{'isDisabledCalendarButton': isDisabledCalendarButton}"
    class="btn-secondary"
    data-cy="datepicker-button-set-today"
    id="setToday"
    type="button">Today
  </button>
</ng-template>

